import * as React from 'react'
import { CalloutParagraph } from './core'
import styled from 'styled-components'

const Summary = styled(CalloutParagraph)`
  width: 100%;
  text-align: center;
  margin: 40vh auto 35vh auto;
  max-width: 850px;
  padding: 0 20px;
  box-sizing: border-box;
`

export default function ServicesSummary(props) {
    return (
        <Summary>
            Crafting delightful digital experiences for over a decade.<br />
            Tyler works with clients to conceptualize, build, and launch web applications, analytic capabilities, and connected objects.
        </Summary>
    )
}



// WEBPACK FOOTER //
// ./src/components/ServicesSummary.js